import {useEffect,useRef,useState} from 'react';
import {useAuth} from '../../Maindashboard/Context/AuthContext';

const API='/api';
export function ServerPageStatus({pagination:p}){
 return <>{p.loading&&<p role="status" className="p-3 text-sm text-gray-400">Loading page…</p>}{p.error&&<p role="alert" className="p-3 text-sm text-red-300">{p.error} <button type="button" onClick={p.retry}>Try again</button></p>}</>;
}
export default function useServerPagination({endpoint,onData,search='',filters={},pageSize=10,page:controlledPage,onPageChange,onPageSizeChange}){
 const auth=useAuth(),scope=auth?.branchId??auth?.user?.branch_id??'';
 const key=JSON.stringify([endpoint,search,filters,scope]);
 const [state,setState]=useState({key,page:1,size:pageSize}),[revision,reload]=useState(0);
 const [result,setResult]=useState({total:0,total_pages:1,summary:{}}),[loading,setLoading]=useState(true),[error,setError]=useState('');
 const callback=useRef(onData);callback.current=onData;
 const external=controlledPage!==undefined,size=external?pageSize:state.size;
 const page=external?controlledPage:(state.key===key?state.page:1);
 useEffect(()=>{
  const controller=new AbortController();let active=true;
  setLoading(true);setError('');
  callback.current([],null);
  const timer=setTimeout(async()=>{
   try{
    const [,term,values]=JSON.parse(key);
    const params=new URLSearchParams({page:String(page),page_size:String(size),search:term,filters:JSON.stringify(values)});
    const res=await fetch(`${API}${endpoint}${endpoint.includes('?')?'&':'?'}${params}`,{credentials:'include',signal:controller.signal});
    const data=await res.json();
    if(!res.ok||data.status!=='success'||!data.pagination)throw Error(data.message||data.detail||'Unable to load this page');
    if(active){setResult(data.pagination);callback.current(data.data||[],data);if(data.pagination.page!==page){if(external)onPageChange?.(data.pagination.page);else setState({key,page:data.pagination.page,size});}}
   }catch(e){if(active&&e.name!=='AbortError'){setError(e.message);callback.current([],null);}}
   finally{if(active)setLoading(false);}
  },search?200:0);
  return()=>{active=false;clearTimeout(timer);controller.abort();};
 // onData and controlled setters are deliberately read through the current render;
 // their changing function identity must not restart the request.
 // eslint-disable-next-line react-hooks/exhaustive-deps
 },[endpoint,key,page,size,revision,search]);
 const total=result.total||0,pages=Math.max(1,result.total_pages||1),current=Math.min(page,pages);
 return {reload:()=>reload(x=>x+1),summary:result.summary||{},pagination:{
  total,page:current,pages,size,start:(current-1)*size,end:Math.min(current*size,total),loading,error,
  setPage:value=>{const next=Math.max(1,Math.min(Number(value)||1,pages));if(external)onPageChange?.(next);else setState({key,page:next,size});},
  setSize:value=>{if(external){onPageSizeChange?.(Number(value));onPageChange?.(1);}else setState({key,page:1,size:Number(value)});},retry:()=>reload(x=>x+1),
 }};
}
